import { useQuery } from "react-query";

import { GET_USER_BY_ID, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getUser } from "api/users";
/** @typedef {import("api/typesDef").User} User */

/**
 * @description Hook to fetch user data by ID using a GET request to
 * `/v3/users/[userId]` endpoint.
 * @param {?string|number} userId - The ID of the user to fetch
 * @returns {{user: User|null, userLoading: boolean, isError: boolean }} An object containing user data, loading state, and refetch function
 */
export const useGetUserById = (userId) => {
  const { data, isLoading, refetch, isRefetching, ...rest } = useQuery(
    [GET_USER_BY_ID, userId],
    () => getUser(userId),
    {
      enabled: Boolean(userId),
      staleTime: STALE_TIME_5_MINUTES,
      retry: 3,
    }
  );

  return {
    user: data?.data || null,
    userLoading: isLoading,
    refetchUserData: refetch,
    isUserDataRefetching: isRefetching,
    ...rest,
  };
};
